module.exports = __webpack_public_path__ + "img/product-pp.e97afa0c.svg";